export default "__VITE_ASSET__B3jJ22jF__"